import { useEffect, useMemo, useState } from "react";

import { useRouter } from "next/router";

import addKeyTermsToContentText from "@/view/utils/addKeyTermsToContentText/addKeyTermsToContentText";
import extractKeyTerms from "@/view/utils/extractKeyTerms";
import useLazyKeyTermsGet from "@/view/utils/useLazyKeyTermsGet";

const useKeyTerms = (
  initialRawText: any, // TODO: replace with correct type
  isVocabularySupportEnabled: boolean,
) => {
  const router = useRouter();
  const { query } = router;
  const { contentId, levelId } = query;

  // TODO: replace any with correct type
  const [keyTermData, setKeyTermData] = useState<any>({});
  const [fetchKeyTerms] = useLazyKeyTermsGet();

  const handleKeyTermData = async () => {
    const { data: termData } = await fetchKeyTerms({
      contentId,
      levelId,
      skip: !isVocabularySupportEnabled,
    });

    if (termData !== undefined) {
      setKeyTermData(termData);
    }
  };

  useEffect(() => {
    isVocabularySupportEnabled && handleKeyTermData();
  }, [contentId, isVocabularySupportEnabled, levelId]);

  const rawText = useMemo(() => {
    if (!initialRawText) return;

    const textObj = JSON.parse(JSON.stringify(initialRawText));
    const extractedKeyTerms = extractKeyTerms(keyTermData?.algorithm_output);
    // TODO: remove type casting when addKeyTermsToContentText
    // is converted to typescript
    const updatedText = addKeyTermsToContentText(
      { ...textObj },
      extractedKeyTerms,
    ) as any;

    return !updatedText?.content || !isVocabularySupportEnabled
      ? initialRawText
      : updatedText;
  }, [
    isVocabularySupportEnabled,
    JSON.stringify(initialRawText),
    JSON.stringify(keyTermData),
  ]);

  return { keyTermData, rawText };
};

export default useKeyTerms;
